import React from "react";
import NuMultiSelect from "../NuMultiSelect";
import { getUserDisplayTextForSelect, User } from "js/utils/userUtils";
import { MaxStudentsMessage } from "./maxStudentsMessage";

export const renderTeacherTab = (
	showWarning: boolean,
	isGroup: boolean,
	lastSelectedTeacher: {
		isTeacher: boolean;
		username: string;
	},
	teacherError: string,
	getUsersCb: unknown,
	stagedTeachers: unknown[],
	handleAddClassroomOwnerCb: unknown,
	handleRemoveTeacher: unknown,
	studentCount: number
): JSX.Element => {
	return (
		<div>
			{isGroup ? (
				<div className="ClassroomEdit_modalDescriptionText">Here you can view teachers that can manage this class.</div>
			) : (
				<div className="ClassroomEdit_modalDescriptionText">
					Here you can add or remove teachers that can manage this class. Teachers added here will see this class in their Classwize
					dashboard.
				</div>
			)}

			{showWarning && !isGroup ? (
				<div className="ClassroomEdit_modalDescriptionText--warning">These settings may be overridden when users are synced</div>
			) : (
				<div />
			)}

			<MaxStudentsMessage studentCount={studentCount} />

			{lastSelectedTeacher?.isTeacher === false ? (
				<div className="ClassroomEdit_validationError">
					<i className="fa fa-minus-circle" aria-hidden="true"></i>&nbsp;
					{lastSelectedTeacher.username} is not in a teacher group and cannot be added as a teacher&nbsp;
				</div>
			) : null}

			{teacherError ? (
				<div className="ClassroomEdit_validationError">
					<i className="fa fa-minus-circle" aria-hidden="true"></i>&nbsp;
					{teacherError}
				</div>
			) : null}

			<NuMultiSelect
				allItemsCb={getUsersCb}
				selectedItems={(stagedTeachers as User[]).map((user) => getUserDisplayTextForSelect(user))}
				searchPlaceholder="Enter teacher name to see matches"
				selectedPlaceholder="No teachers selected"
				onAdd={handleAddClassroomOwnerCb}
				onRemove={handleRemoveTeacher}
				title="Teacher(s) of this class"
				dataCyInput="teachers-classroom_selection"
				dataCyItemsContainer="teachers-classroom_container"
				disabled={isGroup}
			/>
			<br />
		</div>
	);
};
